export default __webpack_public_path__ + "static/img/homepage-fg-green.18e9d06.png";